import state from '@/taskpane/state/sidebar-state'
import { clearCachedAccessToken } from '@/taskpane/graph/generated/graph-api-call-with-sso-wrapper'

export default async function sidebarLogoutHandler() {
  state.sidebarIsAuthenticated = false

  state.cirrusToken = null
  state.cirrusRefreshToken = null

  clearCachedAccessToken()
}
